var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"perc_container"},[_c('div',{staticClass:"perc_bar",style:(_vm.bar_style)}),_c('div',{class:_vm.$vuetify.breakpoint.xs ? 'perc_value_xs':'perc_value'},[_vm._v(_vm._s(_vm.value.toFixed(2))+" %")])])
}
var staticRenderFns = []

export { render, staticRenderFns }